import { getConfig } from '@cian/config/browser';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { registry } from '@cian/mf-registry/browser';
import { getTelemetry } from '@cian/telemetry/browser';

import { IApplicationContext, TApplicationContextCustom } from '../../../shared/types/applicationContext';
import { getEventQueue } from '../../../shared/utils/eventQueue/getEventQueue';

export function createContext(): IApplicationContext {
  const config = getConfig();

  const { serializableMap, ...custom } = config.getStrict<TApplicationContextCustom>('applicationContext.custom');

  custom.messagesMap = new Map(serializableMap);

  return {
    config: getConfig(),
    logger: getLogger(),
    httpApi: getHttpApi(),
    telemetry: getTelemetry(),
    custom,
    microfrontendsRegistry: registry(),
    eventQueue: getEventQueue(),
  };
}
